import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';

@Injectable()
export class HandleLinearMeterChangeCommand implements OnFieldChanged {
  constructor() {}

  async onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): Promise<void> {
    // Reset pump length
    value = value || 0;
    const config = form.config.find((conf) => conf.name === SpecFieldNames.LINEAR_METERS);
    if (config && !config.hidden) {
      formGroup.get(SpecFieldNames.PIPE_QUANTITY).setValue(Math.ceil(value / 3));
    }
  }
}
